import React from 'react';
import { Button, Modal } from 'react-bootstrap';

// Shown when the address belongs to someone who is already a member of the
// organization the admin picked: there is nothing to invite them to, so this
// only reports it and closes.
const ExistingMemberModal = ({ existingMember, handleClose }) => {
  return (
    <Modal show={existingMember !== null} onHide={handleClose}>
      <Modal.Dialog>
        <Modal.Header closeButton>
          <Modal.Title>User Already in Organization</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>This user is already a member of your organization</p>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="primary" className="btn btn-custom dark" onClick={handleClose}>
            Okay
          </Button>
        </Modal.Footer>
      </Modal.Dialog>
    </Modal>
  );
};

export default ExistingMemberModal;
